/* ============================================================
   KAIRII — command-palette search ("Spotlight")  · spec: kairii-search-spec.md
   Overlay markup: snippets/kairii-search.liquid
   Pieces (live products): Predictive Search section `kairii-predictive`
   Series / Collections: matched client-side over #kr-search-data
   ============================================================ */
(function () {
  var dataEl = document.getElementById('kr-search-data');
  var overlay = document.querySelector('[data-kr-search]');
  if (!dataEl || !overlay) return;

  var CFG = {};
  try { CFG = JSON.parse(dataEl.textContent || '{}'); } catch (e) { CFG = {}; }
  var I = CFG.i18n || {};
  var SERIES = CFG.series || [];
  var COLLS = CFG.collections || [];

  var panel = overlay.querySelector('[data-srch-panel]');
  var input = overlay.querySelector('[data-srch-input]');
  var clearBtn = overlay.querySelector('[data-srch-clear]');
  var kbdHint = overlay.querySelector('[data-srch-kbd]');
  var resultsBox = overlay.querySelector('[data-srch-results]');
  var idleBox = overlay.querySelector('[data-srch-idle]');
  var liveBox = overlay.querySelector('[data-srch-live]');
  var statusBox = overlay.querySelector('[data-srch-status]');

  function announce(text) { if (statusBox) statusBox.textContent = text; }

  var RECENT_KEY = 'kairii-search-recent';
  var isOpen = false;
  var active = 0;
  var items = [];
  var reqId = 0;
  var debounceT = null;
  var lastFocus = null;
  var requestController = null;
  var previousOverflow = '';

  function invalidateRequest() {
    reqId++;
    clearTimeout(debounceT);
    if (requestController) requestController.abort();
    requestController = null;
  }

  function focusableItems() {
    return Array.prototype.slice.call(panel.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'))
      .filter(function (el) { return !el.closest('[hidden]') && el.getClientRects().length > 0; });
  }

  /* ---------------- helpers ---------------- */
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function match(q, hay) {
    var toks = q.toLowerCase().split(/\s+/).filter(Boolean);
    return toks.every(function (tk) { return hay.indexOf(tk) >= 0; });
  }
  var IC_SERIES = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 7v10M7 12h10"/></svg>';
  var IC_COLL = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" aria-hidden="true"><rect x="3" y="4" width="18" height="5" rx="1"/><rect x="3" y="11" width="18" height="9" rx="1"/></svg>';
  var IC_GO = '<svg class="srch__row-go" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg>';

  /* ---------------- open / close ---------------- */
  function openSearch() {
    if (isOpen) return;
    isOpen = true;
    lastFocus = document.activeElement;
    overlay.hidden = false;
    previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    input.value = '';
    setControls('');
    showIdle();
    setTimeout(function () { if (isOpen) { try { input.focus(); } catch (e) {} } }, 50);
  }
  function closeSearch() {
    if (!isOpen) return;
    isOpen = false;
    invalidateRequest();
    overlay.hidden = true;
    document.body.style.overflow = previousOverflow;
    clearTimeout(debounceT);
    input.value = '';
    liveBox.hidden = true; liveBox.innerHTML = '';
    announce('');
    idleBox.hidden = false;
    items = []; active = 0;
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus(); } catch (e) {} }
  }
  function navigate(href) { if (!href) return; closeSearch(); window.location.href = href; }

  function setControls(q) {
    var has = q.length > 0;
    // The × is always shown (it's the close affordance). The "ESC" hint chip
    // only shows while idle. aria-label reflects what the × will do.
    if (kbdHint) kbdHint.hidden = has;
    if (clearBtn) clearBtn.setAttribute('aria-label', has ? (I.clear || 'Clear') : (I.close || 'Close'));
  }

  /* ---------------- idle (no query) ---------------- */
  function showIdle() {
    invalidateRequest();
    announce('');
    liveBox.hidden = true; liveBox.innerHTML = '';
    idleBox.hidden = false;
    renderRecent();
    items = []; active = 0;
  }
  function renderRecent() {
    var ex = idleBox.querySelector('[data-srch-recent]');
    if (ex) ex.remove();
    var rec = getRecent();
    if (!rec.length) return;
    var chips = rec.map(function (term) {
      return '<button class="srch__chip" type="button" data-srch-recent-term>' + esc(term) + '</button>';
    }).join('');
    var html = '<div class="srch__group" data-srch-recent>'
      + '<div class="srch__group-h">' + esc(I.recent || 'Recent') + ' <span class="jp">履歴</span>'
      + '<button class="srch__clear-recent" type="button" data-srch-recent-clear>' + esc(I.clear || 'Clear') + '</button></div>'
      + '<div class="srch__chips">' + chips + '</div></div>';
    idleBox.insertAdjacentHTML('afterbegin', html);
  }

  /* ---------------- results (query present) ---------------- */
  function onQuery() {
    invalidateRequest();
    var q = input.value.trim();
    setControls(q);
    active = 0;
    clearTimeout(debounceT);
    if (!q) { showIdle(); return; }
    showResultsShell(q);
    debounceT = setTimeout(function () { fetchPieces(q); }, 150);
  }
  function runImmediate(q) {
    invalidateRequest();
    active = 0;
    showResultsShell(q);
    fetchPieces(q);
  }
  function showResultsShell(q) {
    idleBox.hidden = true;
    liveBox.hidden = false;
    liveBox.innerHTML = buildSeeAll(q) + buildSeries(q) + buildCollections(q);
    rebuildItems();
  }
  function buildSeeAll(q) {
    return '<button class="srch__all" type="button" data-srch-item data-srch-seeall>'
      + '<span>' + esc(I.seeAll || 'See all results for') + ' <b>“' + esc(q) + '”</b></span>'
      + '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg></button>';
  }
  function buildSeries(q) {
    var ms = SERIES.filter(function (s) { return match(q, ((s.name || '') + ' ' + (s.jp || '')).toLowerCase()); });
    if (!ms.length) return '';
    var rows = ms.map(function (s) {
      return '<a class="srch__row srch__row--lite" href="' + esc(s.url) + '" data-srch-item data-srch-nav>'
        + '<span class="srch__row-ic">' + IC_SERIES + '</span>'
        + '<span class="srch__row-main"><span class="srch__row-t">' + esc(s.name) + '</span>'
        + '<span class="srch__row-series jp">' + esc(s.jp) + '</span></span>' + IC_GO + '</a>';
    }).join('');
    return '<div class="srch__group" data-srch-series-group>'
      + '<div class="srch__group-h">' + esc(I.series || 'Series') + ' <span class="jp">シリーズ</span>'
      + '<span class="srch__group-n">' + ms.length + '</span></div>' + rows + '</div>';
  }
  function buildCollections(q) {
    var ms = COLLS.filter(function (c) { return match(q, ((c.label || '') + ' ' + (c.jp || '')).toLowerCase()); });
    if (!ms.length) return '';
    var rows = ms.map(function (c) {
      var sub = c.count ? (c.count + ' ' + (I.piecesWord || 'pieces')) : '';
      return '<a class="srch__row srch__row--lite" href="' + esc(c.url) + '" data-srch-item data-srch-nav>'
        + '<span class="srch__row-ic">' + IC_COLL + '</span>'
        + '<span class="srch__row-main"><span class="srch__row-t">' + esc(c.label) + '</span>'
        + (sub ? '<span class="srch__row-series">' + esc(sub) + '</span>' : '') + '</span>' + IC_GO + '</a>';
    }).join('');
    return '<div class="srch__group" data-srch-collections-group>'
      + '<div class="srch__group-h">' + esc(I.collections || 'Collections') + ' <span class="jp">コレクション</span>'
      + '<span class="srch__group-n">' + ms.length + '</span></div>' + rows + '</div>';
  }
  function fetchPieces(q) {
    var my = ++reqId;
    var controller = new AbortController();
    requestController = controller;
    function isCurrent() { return my === reqId && isOpen && input.value.trim() === q; }
    var url = CFG.predictiveUrl + '?q=' + encodeURIComponent(q)
      + '&section_id=' + encodeURIComponent(CFG.section)
      + '&resources[type]=product&resources[limit]=6';
    fetch(url, { signal: controller.signal, headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        if (!isCurrent()) return;
        var old = liveBox.querySelector('[data-srch-pieces]'); if (old) old.remove();
        var tmp = document.createElement('div'); tmp.innerHTML = (html || '').trim();
        var group = tmp.querySelector('[data-srch-pieces]');
        if (group) { rerankPieces(group, q); liveBox.appendChild(group); }
        finalize(q);
      })
      .catch(function (error) { if (error.name !== 'AbortError' && isCurrent()) finalize(q); });
  }
  function rerankPieces(group, q) {
    var ql = q.toLowerCase();
    var rows = Array.prototype.slice.call(group.querySelectorAll('.srch__row'));
    function score(el) {
      var name = el.getAttribute('data-name') || '', series = el.getAttribute('data-series') || '', sku = el.getAttribute('data-sku') || '';
      var s = 0;
      if (name.indexOf(ql) === 0) s += 30; else if (name.indexOf(ql) >= 0) s += 16;
      if (sku && sku.indexOf(ql) >= 0) s += 10;
      if (series.indexOf(ql) === 0) s += 6;
      if (el.getAttribute('data-grail') === '1') s += 3;
      if (el.getAttribute('data-new') === '1') s += 1;
      return s;
    }
    rows.sort(function (a, b) {
      var d = score(b) - score(a);
      if (d) return d;
      return (parseInt(a.getAttribute('data-price'), 10) || 0) - (parseInt(b.getAttribute('data-price'), 10) || 0);
    });
    rows.forEach(function (r) { group.appendChild(r); }); // header stays first
  }
  function finalize(q) {
    var oldEmpty = liveBox.querySelector('[data-srch-empty]'); if (oldEmpty) oldEmpty.remove();
    var hasGroups = liveBox.querySelector('[data-srch-series-group], [data-srch-collections-group], [data-srch-pieces]');
    if (!hasGroups) {
      liveBox.insertAdjacentHTML('beforeend',
        '<div class="srch__empty" data-srch-empty><span class="serif">'
        + esc(I.noMatch || 'No pieces match') + ' “' + esc(q) + '”.</span>'
        + '<span class="srch__empty-sub">' + esc(I.noMatchHint || 'Try a character, a series, or a SKU.') + '</span></div>');
    }
    rebuildItems();
    var count = items.filter(function (el) { return !el.hasAttribute('data-srch-seeall'); }).length;
    announce((I.resultsFor || 'Results for') + ' ' + q + ': ' + count);
  }

  /* ---------------- keyboard highlight ---------------- */
  function rebuildItems() {
    items = Array.prototype.slice.call(liveBox.querySelectorAll('[data-srch-item]'));
    if (active >= items.length) active = items.length ? items.length - 1 : 0;
    if (active < 0) active = 0;
    paint();
  }
  function paint(speak) {
    items.forEach(function (el, i) { el.classList.toggle('is-active', i === active); });
    var cur = items[active]; if (cur && cur.scrollIntoView) cur.scrollIntoView({ block: 'nearest' });
    if (speak && cur) announce(cur.textContent.replace(/\s+/g, ' ').trim());
  }
  function fireActive() {
    var q = input.value.trim();
    var el = items[active];
    if (el) fireItem(el, q);
    else if (q) seeAll(q);
  }
  function fireItem(el, q) {
    if (el.hasAttribute('data-srch-seeall')) { seeAll(q); return; }
    if (el.hasAttribute('data-srch-product')) { if (q) remember(q); navigate(el.getAttribute('href')); return; }
    navigate(el.getAttribute('href'));
  }
  function seeAll(q) {
    remember(q);
    navigate(CFG.searchUrl + '?q=' + encodeURIComponent(q) + '&type=product');
  }

  /* ---------------- recents ---------------- */
  function getRecent() { try { return JSON.parse(localStorage.getItem(RECENT_KEY) || '[]'); } catch (e) { return []; } }
  function setRecent(a) { try { localStorage.setItem(RECENT_KEY, JSON.stringify(a.slice(0, 6))); } catch (e) {} }
  function remember(term) {
    term = (term || '').trim(); if (!term) return;
    var a = getRecent().filter(function (x) { return x.toLowerCase() !== term.toLowerCase(); });
    a.unshift(term); setRecent(a);
  }

  /* ---------------- events ---------------- */
  input.addEventListener('input', onQuery);

  overlay.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { e.preventDefault(); closeSearch(); return; }
    if (e.key === 'Tab') {
      var focusable = focusableItems();
      var first = focusable[0] || input;
      var last = focusable[focusable.length - 1] || input;
      if (e.shiftKey && (document.activeElement === first || !panel.contains(document.activeElement))) {
        e.preventDefault(); last.focus();
      } else if (!e.shiftKey && (document.activeElement === last || !panel.contains(document.activeElement))) {
        e.preventDefault(); first.focus();
      }
      return;
    }
    if (liveBox.hidden || e.target !== input || e.isComposing) return;
    if (e.key === 'ArrowDown') { e.preventDefault(); if (items.length) { active = (active + 1) % items.length; paint(true); } }
    else if (e.key === 'ArrowUp') { e.preventDefault(); if (items.length) { active = (active - 1 + items.length) % items.length; paint(true); } }
    else if (e.key === 'Enter') { e.preventDefault(); fireActive(); }
  });

  liveBox.addEventListener('focusin', function (e) {
    var el = e.target.closest('[data-srch-item]');
    var index = items.indexOf(el);
    if (index >= 0) { active = index; paint(); }
  });

  // close on scrim (mousedown on the overlay itself, not the panel)
  overlay.addEventListener('mousedown', function (e) { if (e.target === overlay) closeSearch(); });

  // clicks on any selectable row / nav chip (idle + live)
  resultsBox.addEventListener('click', function (e) {
    var el = e.target.closest('[data-srch-item], [data-srch-nav]');
    if (!el) return;
    e.preventDefault();
    fireItem(el, input.value.trim());
  });

  // hover shares the keyboard highlight (results only)
  liveBox.addEventListener('mouseover', function (e) {
    var el = e.target.closest('[data-srch-item]'); if (!el) return;
    var i = items.indexOf(el); if (i >= 0 && i !== active) { active = i; paint(); }
  });

  // recents (idle) — term click + clear
  idleBox.addEventListener('click', function (e) {
    var clr = e.target.closest('[data-srch-recent-clear]');
    if (clr) { e.preventDefault(); setRecent([]); renderRecent(); return; }
    var term = e.target.closest('[data-srch-recent-term]');
    if (term) {
      e.preventDefault();
      input.value = term.textContent;
      setControls(input.value.trim());
      runImmediate(input.value.trim());
      input.focus();
    }
  });

  // The × closes the palette. If the user has typed something, the first click
  // clears it back to idle; from idle (empty) it closes.
  if (clearBtn) clearBtn.addEventListener('click', function () {
    if (input.value) { input.value = ''; setControls(''); showIdle(); input.focus(); }
    else { closeSearch(); }
  });

  // triggers: header button(s) — delegated so it survives section re-renders
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-kr-search-open]');
    if (t) { e.preventDefault(); openSearch(); }
  });

  // global shortcuts: Esc closes from anywhere; Cmd/Ctrl-K anywhere; "/" when not typing
  document.addEventListener('focusin', function (e) {
    if (isOpen && !overlay.contains(e.target)) input.focus();
  });
  document.addEventListener('keydown', function (e) {
    if (isOpen && e.key === 'Escape') { e.preventDefault(); closeSearch(); return; }
    if ((e.key === 'k' || e.key === 'K') && (e.metaKey || e.ctrlKey)) {
      e.preventDefault(); isOpen ? closeSearch() : openSearch(); return;
    }
    if (e.key === '/' && !isOpen) {
      var a = document.activeElement, tag = a && a.tagName;
      var typing = a && (a.isContentEditable || tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT');
      if (!typing) { e.preventDefault(); openSearch(); }
    }
  });
})();
